import { Scope } from './types';
import { IShellDAO } from '../../dao/IShellDAO';
import { AbstractRepository } from '../../core/repositories/AbstractRepository';
import { internalLogger } from '../../interface/v1/clientOsLogger';

export class ScopeRepository extends AbstractRepository<Scope[]> {
  constructor({
    shellDAO,
    enableSanitizer = false
  }: {
    shellDAO: IShellDAO;
    enableSanitizer?: boolean;
  }) {
    super({
      shellDAO: shellDAO,
      prefixKey: 'jshellUserScopes',
      enableSanitizer
    });
  }

  saveAll(): void {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'ScopeRepository',
      methodName: 'saveAll()',
      message: 'Not supported in ScopeRepository.'
    });
    throw new Error('Method not implemented.');
  }

  findAll(id?: string): Scope[][] {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'ScopeRepository',
      methodName: 'findAll()',
      message: 'Not supported in ScopeRepository.',
      id
    });
    throw new Error('Method not implemented.');
  }

  delete(): boolean {
    /* istanbul ignore next */
    internalLogger?.debug?.d5?.({
      className: 'ScopeRepository',
      methodName: 'delete()',
      message: 'Not supported in ScopeRepository.'
    });
    throw new Error('Method not implemented.');
  }
}
